// extracted by mini-css-extract-plugin
export default {"label":"SM99uUut"};